import React, {Component} from 'react';
import {connect} from 'react-redux';
import {injectIntl, defineMessages} from 'react-intl';
import {AlertInfo} from '@homeaway/react-alerts';
import {SvgDestinationUrgency, SvgClose} from './icon-definitions';
import {UrgencyMessagesLoader} from './UrgencyMessagesLoader';
import {pushEdapEvent} from '../../../utils/edap';

export const MIN_VISITOR_COUNT = 10;

const messages = defineMessages({
    destinationUrgencyTitle: {
        id: 'destinationUrgency.title',
        defaultMessage: 'UNTRANSLATED'
    },
    destinationUrgencyMessage: {
        id: 'destinationUrgency.message',
        defaultMessage: 'UNTRANSLATED'
    }
});

const mapStateToProps = (state) => ({
    brandName: state.config.site.brandName,
    simpleDestinationName: state.destination.details.simpleName,
    visitorSearchCount: state.destination.urgencyVisitorCount || 0
});

export class DestinationUrgencyComponent extends Component {
    onAlertClosed() {
        pushEdapEvent('generic.event', {
            actionlocation: 'destination-urgency-message',
            eventcategory: 'destination-urgency-message',
            eventaction: 'close-message'
        });
    }

    render() {
        const {
            intl: {formatMessage, formatNumber},
            visitorSearchCount,
            simpleDestinationName
        } = this.props;

        const title = formatMessage(messages.destinationUrgencyTitle);
        const message = formatMessage(messages.destinationUrgencyMessage, {
            visitorSearchCount: formatNumber(visitorSearchCount),
            simpleDestinationName
        });

        if (visitorSearchCount < MIN_VISITOR_COUNT) {
            return <UrgencyMessagesLoader />;
        }

        return (
            <div className="container destination-urgency">
                <div className="row">
                    <div className="col-xs-12">
                        <SvgDestinationUrgency />
                        <SvgClose />
                        <AlertInfo
                            svg="svg-destination-urgency"
                            dismissible
                            closeText="Dismiss message"
                            onAlertClosed={this.onAlertClosed}
                        >
                            <span>
                                <strong>{title}</strong>
                                <span> {message}</span>
                            </span>
                        </AlertInfo>
                    </div>
                </div>
            </div>
        );
    }
}

export const DestinationUrgency = injectIntl(
    connect(mapStateToProps)(DestinationUrgencyComponent)
);
export default DestinationUrgency;
